import { crudRoutes, expeditionRoutes, generalRoutes } from "./routesConstants";

import userRoles from "../constants/userRoles";

import { Error404 } from "../pages/Error/Error404";
import { Error500 } from "../pages/Error/Error500";
import { ErrorsPage } from "../pages/Error/ErrorPage";
import CreateAwb from "../pages/CreateAwb";
import CreateBin from "../pages/CreateBin";
import ExpeditionScheduleWorkingPoints from "../pages/Expedition/ClientWorkingPoints";
import ExpeditionScheduleWorkingPointsOrganise from "../pages/Expedition/ClientWorkingPoints/ClientWorkingPointsOrganise";
import UndeliveredAwb from "../pages/Expedition/UndeliveredAwb";
import UndeliveredBins from "../pages/Expedition/UndeliveredBins";
import DeliveredAwbHistory from "../pages/Expedition/DeliveredAwbHistory";
import DeliverySheets from "../pages/Expedition/DeliverySheets";

const errorRoutes = [
  {
    id: "Error",
    path: "error/*",
    element: <ErrorsPage />,
  },
  {
    id: "Error500",
    path: "/error/500",
    element: <Error500 />,
  },
  {
    id: "Error404",
    path: "*",
    element: <Error404 />,
  },
];

const transport = [
  {
    id: userRoles.PREVIEW_USERS,
    path: `/${generalRoutes.createAwb}`,
    element: <CreateAwb />,
  },
  {
    id: userRoles.PREVIEW_USERS,
    path: `/${generalRoutes.createBin}`,
    element: <CreateBin />,
  },
];

const expedition = [
  {
    id: userRoles.SCHEDULE_WORKING_POINTS,
    path: `/${expeditionRoutes.clientWorkingPoints}`,
    element: <ExpeditionScheduleWorkingPoints />,
  },
  {
    id: userRoles.WORKING_POINTS_ORGANIZE,
    path: `/${expeditionRoutes.clientWorkingPoints}/${expeditionRoutes.organize}`,
    element: <ExpeditionScheduleWorkingPointsOrganise withUpdate />,
  },
  {
    id: userRoles.WORKING_POINTS_ORGANIZE,
    path: `/${expeditionRoutes.clientWorkingPoints}/${crudRoutes.create}`,
    element: <ExpeditionScheduleWorkingPointsOrganise />,
  },
  {
    id: userRoles.UNDELIVERED_AWB,
    path: `/${expeditionRoutes.undeliveredAwb}`,
    element: <UndeliveredAwb />,
  },
  {
    id: userRoles.UNDELIVERED_BINS,
    path: `/${expeditionRoutes.undeliveredBins}`,
    element: <UndeliveredBins />,
  },
  {
    id: userRoles.DELIVERED_AWB_HISTORY,
    path: `/${expeditionRoutes.deliveredAwbHistory}`,
    element: <DeliveredAwbHistory />,
  },

  {
    id: userRoles.DELIVERY_SHEETS,
    path: `/${expeditionRoutes.deliverySheets}`,
    element: <DeliverySheets />,
  },
];

function useAppRoutes() {
  return {
    errorRoutes,
    allRoutes: [...transport, ...expedition],
    transport: transport,
    expedition: expedition,
  };
}

export default useAppRoutes;
